import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Survey } from '~src/modules/surveys/interfaces';
import { ScheduleI } from '~src/interfaces/schedule.interface';
import { StoreI } from '~src/rootReducer';

import SchedulesItem from './scheduleItem/SchedulesItem';

interface OwnProps {
  survey: Survey | null;
  surveyId: string;
  questionCount: number;
}

interface StateProps {
  schedules?: { [key: string]: ScheduleI };
  loadingSchedules: boolean;
}

type Props = OwnProps & StateProps & RouteComponentProps<any>;

interface State {
  questionCount: number;
  surveyId: string;
}

class SchedulesContainer extends React.Component<Props, State> {
  state = {
    questionCount: this.props.questionCount,
    surveyId: this.props.match.params.surveyId,
  };

  render() {
    return (
      this.props.questionCount > 0 &&
      this.props.schedules &&
      this.props.survey && (
        <div style={{ paddingBottom: '3rem' }}>
          {!this.props.loadingSchedules && (
            <SchedulesItem
              schedule={
                Object.values(this.props.schedules).length > 0 ? Object.values(this.props.schedules)[0] : null
              }
              survey={this.props.survey}
            />
          )}
        </div>
      )
    );
  }
}

function mapStateToProps(state: StoreI): StateProps {
  return {
    schedules: state.surveyManagement.schedules.byId,
    loadingSchedules: state.surveyManagement.schedules.loading,
  };
}

const SchedulesContainerWithRouter = withRouter(SchedulesContainer);
const SchedulesContainerSuperComponent = connect(mapStateToProps)(SchedulesContainerWithRouter);

export default SchedulesContainerSuperComponent;
